import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-testimonial',
  templateUrl: './section-testimonial.component.html',
  styleUrls: ['./section-testimonial.component.css']
})
export class SectionTestimonialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
